import React, { forwardRef } from "react";
import "../styles/select.css";

const Select = forwardRef(({
  label,
  options = [],
  value,
  onChange,
  placeholder,
  id,
  name,
}, ref) => {
  return (
    <div className="selectWrapper">
      {label && <label htmlFor={id}>{label}</label>}
      <select
        id={id}
        name={name}
        value={value}
        onChange={(e) => onChange(e)}
        className="selectInput"
        ref={ref}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
})
export default Select;
